<template>
  <div
    v-show="show"
    aria-live="assertive"
    class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
  >
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <!--
        Notification panel, dynamically insert this into the live region when it needs to be displayed

        Entering: "transform ease-out duration-300 transition"
          From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          To: "translate-y-0 opacity-100 sm:translate-x-0"
        Leaving: "transition ease-in duration-100"
          From: "opacity-100"
          To: "opacity-0"
      -->
      <div
        class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
      >
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <i
                v-if="type === 'success'"
                class="fa fa-check-circle h-6 w-6 text-green-500"
              />
              <i
                v-if="type === 'warning' || type === 'error'"
                class="fa fa-exclamation-triangle h-6 w-6 text-orange-500"
              />
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium text-gray-900">
                {{ text }}
              </p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button
                class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <span class="sr-only">Sluiten</span>
                <i
                  class="fa fa-times h-5 w-5"
                  @click="hide"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      type: 'success',
      text: '',
    };
  },

  mounted () {
    // @todo: animate
    this.$eventHub.$on('notification', this.showNotification);
  },

  destroyed () {
    this.$eventHub.$off('notification', this.showNotification);
  },

  methods: {
    showNotification (type, text, playSound = false) {
      this.show = true;
      this.type = type;
      this.text = text;

      if (playSound) {
        const sound = new Audio('/audio/toast.mp3');
        sound.play();
      }

      this.hideTimeout = setTimeout(() => this.hide(), 5000);
    },

    hide () {
      clearTimeout(this.hideTimeout);
      this.show = false;
    },
  },
};
</script>
